import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function SupportCTA() {
  return <section className="py-12 bg-gradient-to-r from-brand-purple-600 to-brand-purple-700 text-white" data-id="element-256">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-257">
        <h2 className="text-3xl font-bold mb-6" data-id="element-258">Need Help?</h2>
        <p className="text-brand-purple-100 text-lg mb-8" data-id="element-259">
          Our local support team is here to answer your questions about classes,
          requirements, or technical issues.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-260">
          <a href="tel:6023776207" className="group flex items-center bg-white text-brand-purple-900 px-8 py-4 rounded-full font-bold text-xl hover:bg-brand-orange-400 hover:text-white transition-colors shadow-lg" data-id="element-261">
            <Phone className="w-6 h-6 mr-3 group-hover:animate-pulse" data-id="element-262" />
            602-377-6207
          </a>
          <span className="text-brand-purple-100 font-medium" data-id="element-263">
            Call, Text, Chat or Email us
          </span>
        </div>
      </div>
    </section>;
}